import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    balance: "", // 余额
  },
  mutations: {
    ['increment'](state, res) {
      state.balance = res;
    },
  },
  actions: { // 这是Vuex中的异步方法
    getMessageList({ commit }) {
      var id = JSON.parse(sessionStorage.getItem("shopData")).shop.id;
      Vue.prototype.$axios
        .post("/park/getBusiness?shopId=" + id, null)
        .then((res) => {
          commit('increment', res.data.shop.balance)  // 执行mutations方法
        }).catch(function (err) {
          // console.log(err);
        });
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js